<!--<ng-container *ngIf="data$ | async as data else loader">-->
<ng-container *ngIf="data else loader">
  <section class="flex column center-vr center">
    <div class="profile-img-container">
      <div class="profile-img flex center-vr center" *ngIf="!data.profileImage">
        {{data.businessName}}</div>
      <div [ngStyle]="{'background-image': 'url(' + data.profileImage + ')'}" class="profile-img flex center-vr center"
        *ngIf="data.profileImage" [class.loading]="isLoading"></div>
      <div class="icon-container flex center-vr center pointer">
        <label class="flex" for="upload-img">
          <i class="fa-light fa-camera"></i>
        </label>
        <input hidden id="upload-img" type="file" accept="image/*" (change)="usePhoto($event)">
      </div>
      <div class="loader-wrapper" *ngIf="isLoading">
        <lib-home365-loader size="m"></lib-home365-loader>
      </div>
    </div>
    <div class="business-name">{{data.name}}</div>
  </section>

  <ng-container [formGroup]="form">
    <span class="bolder vendor-title">Personal information</span>
    <div id="vendor_profile_form" [class.tenant]="isTenant" class="grid grid-column-gap" [class.mobile]="isMobile">

      <mat-form-field id="first_name">
        <input matInput type="text" formControlName="firstName" placeholder="First name">
      </mat-form-field>

      <mat-form-field id="last_name">
        <input matInput type="text" formControlName="lastName" placeholder="Last name">
      </mat-form-field>

      <mat-form-field id="email">
        <input matInput type="email" formControlName="email" placeholder="Email">
        <mat-error>{{emailError}}</mat-error>
      </mat-form-field>

      <mat-form-field id="dob" *ngIf="isTenant">
        <mat-label [class.pink]="focusOnDOB">Date of Birth</mat-label>
        <input #dateInput matInput [max]="minDate" [matDatepicker]="picker" formControlName="birthday">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="birthday?.errors?.['required']">This field is required</mat-error>
      </mat-form-field>

      <mat-form-field id="mobile_phone">
        <input matInput type="text" formControlName="mobilePhone" placeholder="Phone Number" readonly>
      </mat-form-field>

      <mat-form-field id="property_address" *ngIf="isTenant">
        <input matInput type="text" formControlName="propertyAddress" placeholder="Rental address" readonly>
      </mat-form-field>
    </div>
  </ng-container>

</ng-container>

<ng-template #loader>
  <div class="flex center center-vr max-height-container">
    <lib-home365-loader size="l"></lib-home365-loader>
  </div>
</ng-template>
